<div class="container-fluid footer-wrapper">
    <div class="row">
        <div class="col-12 d-block d-md-none common-accordion footer-accordion">
            <accordion [isAnimated]="true" [closeOthers]="true">
                <accordion-group heading="Products">
                    <div class="footer-list">
                        <ul>
                            <li>
                                <a (click)="changeCategory('All')" title="All">All</a>
                            </li>
                            <li *ngFor="let cat of categories">
                                <a (click)="changeCategory(cat)" title="{{cat?.name}}">{{cat?.name}}</a>
                            </li>
                        </ul>
                    </div>
                </accordion-group>
                <accordion-group heading="Quick Links">
                    <div class="footer-list">
                        <ul>

                            <li>
                                <a routerLink="/terms" title="Legal">Legal</a>
                            </li>
                            <li>
                                <a routerLink="/about" title="About World of Sweets">About World Of Sweets </a>
                            </li>
                            <li>
                                <a routerLink="/privacy-policy" title="Privacy Policy">Privacy Policy</a>
                            </li>
                            <li>
                                <a routerLink="/contact-us" title="Contact Us">Contact Us</a>
                            </li>
                        </ul>

                    </div>
                </accordion-group>
            </accordion>
        </div>

        <div class="col-12 col-lg-2 order-lg-0 order-3 mt-md-5 mt-4 mt-lg-0">
            <div class="footer-logo">
                <a href="/" title="logo">
                    <img src="../../assets/images/bonds-logo-footer.svg" alt="footer-logo" />
                </a>
                <span>©{{current_date}}. All rights reserved.</span>
            </div>
        </div>


        <div class="col-12 col-md-6 col-lg-2 mt-lg-0 mt-5  d-none d-md-flex">
            <div class="footer-list">
                <h2>Location</h2>
                <address>
                    <!-- Bonds of London <br>
                    Unit A, Hamilton Road, <br>
                    Sutton-in-Ashfield, <br>
                    Nottinghamshire, <br>
                    NG17 5LD -->
                    <div [innerHTML]="location"></div>
                </address>
            </div>
        </div>

        <div class="col-12 col-md-6 col-lg-2 mt-lg-0 mt-5  d-none d-md-block separator-line">
            <div class="footer-list">
                <h2>Quick Links</h2>
                <ul>

                    <li>
                        <a routerLink="/terms" title="Legal">Legal</a>
                    </li>
                    <li>
                        <a routerLink="/about" title="About World of Sweets">About World Of Sweets </a>
                    </li>
                    <li>
                        <a routerLink="/privacy-policy" title="Privacy Policy">Privacy Policy</a>
                    </li>
                    <li>
                        <a routerLink="/contact-us" title="Contact Us">Contact Us</a>
                    </li>
                </ul>
            </div>
        </div>

        <div class="col-12 col-lg-6  d-none d-md-block">
            <div class="footer-list api-list">
                <h2>Products</h2>
                <div class="row">
                    <div class=" col-12">
                        <ul>
                            <li>
                                <a (click)="changeCategory('All')" title="All">All</a>
                            </li>
                            <li *ngFor="let cat of categories">
                                <a (click)="changeCategory(cat)" title="{{cat.name}}">{{cat.name}}</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>